import React, { Component } from 'react';
import ListUser from './ListUser'
import * as Business from '../../utils/business'

export default class User extends Component {
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        {Business.isHasRole([Business.ROLE_DEFINE_MAP.UPDATE_USER, Business.ROLE_DEFINE_MAP.CREATE_USER, Business.ROLE_DEFINE_MAP.DELETE_USER]) && <ListUser />}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/User/index.js